var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoMasspayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 31.194,
    viewBox: "0 0 52 31.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43351",
    "data-name": "Caminho 43351",
    d: "M38.432,30.131h-26.2A4.3,4.3,0,0,1,8,25.764a1.733,1.733,0,1,1,3.466,0,.867.867,0,0,0,.763.9h26.2a.866.866,0,0,0,.763-.9V19.733a1.733,1.733,0,1,1,3.466,0v6.031a4.3,4.3,0,0,1-4.229,4.367Z",
    transform: "translate(4.141 1.063)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43352",
    "data-name": "Caminho 43352",
    d: "M40.927,19.131A1.733,1.733,0,0,1,39.194,17.4V11.367a.866.866,0,0,0-.763-.9h-26.2a.866.866,0,0,0-.763.9,1.733,1.733,0,1,1-3.466,0A4.3,4.3,0,0,1,12.229,7h26.2a4.3,4.3,0,0,1,4.229,4.367V17.4a1.733,1.733,0,0,1-1.733,1.733Z",
    transform: "translate(4.141 -7)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43353",
    "data-name": "Caminho 43353",
    d: "M34.067,25.864h-8.8A4.263,4.263,0,0,1,21,21.6V16.263A4.263,4.263,0,0,1,25.263,12h8.8a4.263,4.263,0,0,1,4.263,4.263V21.6A4.263,4.263,0,0,1,34.067,25.864Zm-8.8-10.4a.815.815,0,0,0-.8.8V21.6a.815.815,0,0,0,.8.8h8.8a.815.815,0,0,0,.8-.8V16.263a.815.815,0,0,0-.8-.8Z",
    transform: "translate(13.67 -3.335)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43354",
    "data-name": "Caminho 43354",
    d: "M16.6,20.466H2.733a1.733,1.733,0,1,1,0-3.466H16.6a1.733,1.733,0,1,1,0,3.466Z",
    transform: "translate(-0.99 0.33)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43355",
    "data-name": "Caminho 43355",
    d: "M10.737,25.4a1.733,1.733,0,0,1-1.23-2.963L11.76,20.2,9.507,17.966a1.74,1.74,0,0,1,2.461-2.461l3.466,3.466a1.733,1.733,0,0,1,0,2.461L11.968,24.9A1.733,1.733,0,0,1,10.737,25.4Z",
    transform: "translate(4.869 -1.139)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43356",
    "data-name": "Caminho 43356",
    d: "M18.6,15.466H4.733a1.733,1.733,0,0,1,0-3.466H18.6a1.733,1.733,0,1,1,0,3.466Z",
    transform: "translate(0.477 -3.335)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43357",
    "data-name": "Caminho 43357",
    d: "M6.2,20.4a1.733,1.733,0,0,1-1.23-.5L1.507,16.432a1.733,1.733,0,0,1,0-2.461l3.466-3.466a1.74,1.74,0,1,1,2.461,2.461L5.181,15.2l2.253,2.236A1.733,1.733,0,0,1,6.2,20.4Z",
    transform: "translate(-0.994 -4.804)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMasspayment);
export default __webpack_public_path__ + "static/media/ico-masspayment.ed5d6156b1f896d2ba2af3f852f9605c.svg";
export { ForwardRef as ReactComponent };